import {
  TRANSACTION_LIST_REQUEST,
  TRANSACTION_LIST_SUCCESS,
  TRANSACTION_LIST_FAIL,
  TRANSACTION_LIST_RESET,
  TRANSACTION_STATS_REQUEST,
  TRANSACTION_STATS_SUCCESS,
  TRANSACTION_STATS_FAIL,
  TRANSACTION_STATS_RESET,
  TRANSACTION_INCOMPLETE_REQUEST,
  TRANSACTION_INCOMPLETE_SUCCESS,
  TRANSACTION_INCOMPLETE_FAIL,
  TRANSACTION_INCOMPLETE_RESET,
  ORDER_TRANSACTION_REQUEST,
  ORDER_TRANSACTION_SUCCESS,
  ORDER_TRANSACTION_FAIL,
  ORDER_TRANSACTION_RESET,
  TRANSACTION_SINGLE_REQUEST,
  TRANSACTION_SINGLE_SUCCESS,
  TRANSACTION_SINGLE_FAIL,
  TRANSACTION_SINGLE_RESET,
  CREATE_TRANSACTION_REQUEST,
  CREATE_TRANSACTION_SUCCESS,
  CREATE_TRANSACTION_FAIL,
  CREATE_TRANSACTION_RESET,
  MPESA_STK_TRANSACTION_REQUEST,
  MPESA_STK_TRANSACTION_SUCCESS,
  MPESA_STK_TRANSACTION_FAIL,
  MPESA_STK_TRANSACTION_RESET,
  UPDATE_TRANSACTION_REQUEST,
  UPDATE_TRANSACTION_SUCCESS,
  UPDATE_TRANSACTION_FAIL,
  UPDATE_TRANSACTION_RESET,
  DELETE_TRANSACTION_REQUEST,
  DELETE_TRANSACTION_SUCCESS,
  DELETE_TRANSACTION_FAIL,
  DELETE_TRANSACTION_RESET,
} from "constants/transactionConstants";

export const listTransactionsReducer = (
  state = { transactionsList: [] },
  action
) => {
  switch (action.type) {
    case TRANSACTION_LIST_REQUEST:
      return { loading: true, transactionsList: [] };
    case TRANSACTION_LIST_SUCCESS:
      return { loading: false, transactionsList: action.payload };
    case TRANSACTION_LIST_FAIL:
      return { loading: false, error: action.payload };
    case TRANSACTION_LIST_RESET:
      return [];
    default:
      return state;
  }
};

export const statsTransactionsReducer = (
  state = { transactionsStats: [] },
  action
) => {
  switch (action.type) {
    case TRANSACTION_STATS_REQUEST:
      return { loading: true };
    case TRANSACTION_STATS_SUCCESS:
      return { loading: false, transactionsStats: action.payload };
    case TRANSACTION_STATS_FAIL:
      return { loading: false, error: action.payload };
    case TRANSACTION_STATS_RESET:
      return [];
    default:
      return state;
  }
};

export const incompleteTransactionsReducer = (
  state = { transactionsIncomplete: [] },
  action
) => {
  switch (action.type) {
    case TRANSACTION_INCOMPLETE_REQUEST:
      return { loading: true };
    case TRANSACTION_INCOMPLETE_SUCCESS:
      return { loading: false, transactionsIncomplete: action.payload };
    case TRANSACTION_INCOMPLETE_FAIL:
      return { loading: false, error: action.payload };
    case TRANSACTION_INCOMPLETE_RESET:
      return [];
    default:
      return state;
  }
};

export const orderTransactionReducer = (
  state = { transactionOrder: [] },
  action
) => {
  switch (action.type) {
    case ORDER_TRANSACTION_REQUEST:
      return { loading: true };
    case ORDER_TRANSACTION_SUCCESS:
      return {
        loading: false,
        transactionOrder: action.payload,
        success: true,
      };
    case ORDER_TRANSACTION_FAIL:
      return { loading: false, error: action.payload };
    case ORDER_TRANSACTION_RESET:
      return { transactionOrder: [] };
    default:
      return state;
  }
};

export const singleTransactionReducer = (
  state = { transactionSingle: {} },
  action
) => {
  switch (action.type) {
    case TRANSACTION_SINGLE_REQUEST:
      return { loading: true, transactionSingle: {} };
    case TRANSACTION_SINGLE_SUCCESS:
      return { loading: false, transactionSingle: action.payload };
    case TRANSACTION_SINGLE_FAIL:
      return { loading: false, error: action.payload };
    case TRANSACTION_SINGLE_RESET:
      return {};
    default:
      return state;
  }
};

export const createTransactionReducer = (
  state = { transactionCreate: {} },
  action
) => {
  switch (action.type) {
    case CREATE_TRANSACTION_REQUEST:
      return { loading: true, transactionCreate: {} };
    case CREATE_TRANSACTION_SUCCESS:
      return { loading: false, transactionCreate: action.payload };
    case CREATE_TRANSACTION_FAIL:
      return { loading: false, error: action.payload };
    case CREATE_TRANSACTION_RESET:
      return {};
    default:
      return state;
  }
};

export const mpesaStkTransactionReducer = (
  state = { mpesaStk: {} },
  action
) => {
  switch (action.type) {
    case CREATE_TRANSACTION_REQUEST:
      return { loading: true, mpesaStk: {} };
    case CREATE_TRANSACTION_SUCCESS:
      return { loading: false, mpesaStk: action.payload };
    case CREATE_TRANSACTION_FAIL:
      return { loading: false, error: action.payload };
    case CREATE_TRANSACTION_RESET:
      return {};
    default:
      return state;
  }
};

export const updateTransactionReducer = (
  state = { transactionUpdate: {} },
  action
) => {
  switch (action.type) {
    case UPDATE_TRANSACTION_REQUEST:
      return { loading: true, transactionUpdate: {} };
    case UPDATE_TRANSACTION_SUCCESS:
      return { loading: false, transactionUpdate: action.payload };
    case UPDATE_TRANSACTION_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_TRANSACTION_RESET:
      return {};
    default:
      return state;
  }
};
export const deleteTransactionReducer = (
  state = { transactionDelete: [] },
  action
) => {
  switch (action.type) {
    case DELETE_TRANSACTION_REQUEST:
      return { loading: true, transactionDelete: [] };
    case DELETE_TRANSACTION_SUCCESS:
      return { loading: false, transactionDelete: action.payload };
    case DELETE_TRANSACTION_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_TRANSACTION_RESET:
      return [];
    default:
      return state;
  }
};
